import { setLocale as setYupLocale } from 'yup';

import nav from './nav';
import schemaMessages from './schemaMessages';

setYupLocale(schemaMessages);

export { nav };
